import React from "react";
import { ReactSVG } from "react-svg";

import freeShippingBadge from "../../../images/Free-Shipping-Badge.svg";

export const FreeShippingBadge = () => <ReactSVG src={freeShippingBadge.src} />;
